import {
  Mutation,
  MutationCache,
  Query,
  QueryCache,
  QueryClient
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { GraphError } from "@microsoft/microsoft-graph-client";
import HttpStatusCode from "types/HttpStatusCode.enum";
import toast from "react-hot-toast";
import { t } from "i18next";
import ErrorResponse from "types/ErrorResponse.types";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: (failureCount, error: AxiosError) => {
        if (!error.isAxiosError) {
          return false;
        } else if (
          error.response?.status === HttpStatusCode.InternalServerError ||
          error.response?.status === HttpStatusCode.GatewayTimeout ||
          error.response?.status === HttpStatusCode.ServiceUnavailable
        ) {
          return failureCount < 1;
        } else {
          return false;
        }
      }
    }
  },
  queryCache: new QueryCache({
    onError: (error: AxiosError<ErrorResponse> & GraphError, query: Query) => {
      const statusCode = error.statusCode || error.response?.status;
      if (statusCode !== HttpStatusCode.NotFound && error.isAxiosError) {
        console.log("queryClient.ts - QueryCache", error);
        let errorMessage = "E.DEFAULT";
        if (error.response?.data.ErrorCode) {
          errorMessage = t(`E.${error.response.data.ErrorCode}`);
          if (error.response?.data.ErrorCode === "ERROR500") {
            errorMessage = `${error.response?.data.ErrorMessage}`;
          }
        } else if (query.meta?.errorMessage) {
          errorMessage = query.meta.errorMessage as string;
        }
        toast.error(t(errorMessage));
      }
    }
  }),
  mutationCache: new MutationCache({
    onError: (error: AxiosError<ErrorResponse>, _, __, mutation: Mutation) => {
      if (error.response?.status !== HttpStatusCode.NotFound) {
        console.log("queryClient.ts - MutationCache", error);
        let errorMessage = "E.DEFAULT";
        if (error.response?.data.ErrorCode) {
          errorMessage = t(`E.${error.response.data.ErrorCode}`);
          if (error.response?.data.ErrorCode === "ERROR500") {
            errorMessage = `${error.response?.data.ErrorMessage}`;
          }
        } else if (mutation.options.meta?.errorMessage) {
          errorMessage = mutation.options.meta.errorMessage as string;
        }
        toast.error(t(errorMessage));
      }
    }
  })
});

export default queryClient;
